import { useState, useEffect } from 'react';

export default function usePlatform() {
	const [isMobilePlatform, setIsMobilePlatform] = useState(false);
	const [isWindowsPlatform, setIsWindowsPlatform] = useState(false);

	useEffect(() => {
		const { userAgent } = navigator;
		if (/iPhone|iPad|iPod|Android|Windows Phone/i.test(userAgent)) {
			setIsMobilePlatform(true);
		} else if (/Mac/i.test(userAgent) && "ontouchend" in document) {
			// NOTE: Safari in iPadOS 13.5 up
			setIsMobilePlatform(true);
		} else if (/Windows/.test(userAgent)) {
			setIsWindowsPlatform(true);
		}
	}, []);

	return { isMobilePlatform, isWindowsPlatform };
}